import { Link } from "react-router";
import { cn } from "@util/helpers";

type KeywordLinksProps = {
  /** The name of the tag */
  tagName: string;
  /** The URL path of the tag */
  tagUrlPath: string;
  /** The class name for the root element */
  className?: string;
};

const KeywordLink = ({
  tagName,
  tagUrlPath,
  className = "",
}: KeywordLinksProps): React.ReactElement => {
  return (
    <Link
      to={tagUrlPath}
      className={cn(
        "border border-gray-675 px-2 text-center font-poppins hover:underline",
        className
      )}
      target="_blank"
      rel="noopener"
    >
      {tagName}
    </Link>
  );
};

export default KeywordLink;
